import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-error',
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent {
  message = input.required<string>();
  close =  input<boolean>();
  onClose = output<void>();
  // _images = inject(ImagesService);

  closeToast() {
    this.onClose.emit();
  }
}
